import State from 'interfaces/state/State';

export const isSwitchOffManagerEventListener$ = (state: State): boolean => state.managerEventListener.isSwitchOffManagerEventListener;
